import React from 'react';
import { Modal } from 'react-bootstrap';
import moment from "moment";

const ViewUserModal = ({ show, onClose, user }) => {
  if (!user) return null;
  return (
    <Modal show={show} size="md" centered onHide={onClose} backdrop="static">
      <div className="modal-simple modal-edit-user">
        <div className="modal-content p-3 p-md-3">
          <Modal.Body className="p-2">
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            <div>
              <div className="text-left mb-4">
                <h3 className="mb-2">Basic</h3>
              </div>
              <div className="row">
                <div className="col-lg-6 mb-3">
                  <h6 className="mb-0">Name</h6>
                  <small className="text-muted">{user?.name}</small>
                </div>
                <div className="col-lg-6 mb-3">
                  <h6 className="mb-0">Phone</h6>
                  <small className="text-muted">{user?.phone_number}</small>
                </div>
                <div className="col-lg-6 mb-3">
                  <h6 className="mb-0">Email</h6>
                  <small className="text-muted">{user?.email}</small>
                </div>
                <div className="col-lg-6 mb-3">
                  <h6 className="mb-0">Onboarding Date</h6>
                  <small className="text-muted">{user?.onboarding_date ? moment(user.onboarding_date).format("DD MMM YY") : "—"}</small>
                </div>
                <div className="col-lg-6 mb-3">
                  <h6 className="mb-0">Address</h6>
                  <small className="text-muted">{user?.address}</small>
                </div>
                <div className="col-lg-6 mb-3">
                  <h6 className="mb-0">Status</h6>
                  <small className="text-muted">{user?.status ? 'Active' : 'Inactive'}</small>
                </div>
              </div>
            </div>
            <div>
              <div className="text-left mb-4">
                <h3 className="mb-2">Role</h3>
              </div>
              <div className="d-flex flex-wrap gap-2">
                <span className="badge bg-label-warning rounded-pill px-3 py-2">{user?.role}</span>
              </div>
            </div>
          </Modal.Body>
        </div>
      </div>
    </Modal>
  );
};

export default ViewUserModal;
